import { BaseStore } from "@deputy-ai/common/jotai";
import type { Atom } from "jotai";
import type { Observable } from "rxjs";

export interface UploadFileStoreOptions {
  uploadFileUrl: Atom<string | undefined>;
}

export type UploadFileApi = (args: { file: File }) => Observable<{
  objectName: string;
}>;

export class UploadFileStore extends BaseStore {
  get uploadFileUrl() {
    return this.options.uploadFileUrl;
  }

  #uploadFileApi?: UploadFileApi;

  constructor(private readonly options: UploadFileStoreOptions) {
    super();
  }

  setUploadFileApi(uploadFileApi: UploadFileApi) {
    this.#uploadFileApi = uploadFileApi;
  }

  uploadFile(args: { file: File }) {
    if (!this.#uploadFileApi) {
      throw new Error("uploadFileApi is not set");
    }
    return this.#uploadFileApi(args);
  }
}
